import React from 'react';
import { DatePicker, Heading } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';

const DatePickerCustom = ({
  endDate, disableDates, selectedDate, setSelectedDate, startDate,
}) => {
  const onDateChange = (event, date2) => {
    setSelectedDate(date2.dateString);
  };

  // Helper to convert MM/DD/YYYY to YYYY-MM-DD
  const formatToISO = (dateStr) => {
    if (!dateStr) return '';
    const [month, day, year] = dateStr.split('/');
    if (!month || !day || !year) return '';
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  };

  const isoStartDate = formatToISO(startDate);

  return (
    <div className="width-full" style={{ textAlign: 'start', width: '100%' }}>
      <Heading
        headingStyle="heading3"
        level={3}
      >
        Date
      </Heading>
      {/* maxDate is iso foramt */}
      <DatePicker
        id="dpicker"
        date={selectedDate}
        onDateChange={onDateChange}
        aria-labelledby="dpd-label"
        datesDescribedBy="dpd-label"
        format="MM/DD/YYYY"
        placeholder="MM/DD/YYYY"
        minDate={isoStartDate}
        maxDate={endDate}
        className="width-full flex flex-align-stretch"
        style={{ width: '100%' }} // Use width instead of minWidth
        disabledDates={disableDates}
        footer={(
          <p className="body-2">
            Some future dates may be unavailable due to your Payment Due Date and Statement Balance.
          </p>
            )}
      />
    </div>
  );
};
export default DatePickerCustom;

DatePickerCustom.propTypes = {
  endDate: PropTypes.string.isRequired,
  disableDates: PropTypes.arrayOf(PropTypes.string),
  selectedDate: PropTypes.string.isRequired,
  setSelectedDate: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
};
